/* em-recovery-pdp.js: fills the two live parts of the recovery product page sections
 * (snippets/recovery-pdp-layer.liquid).
 *   "Which length?"  every recovery length with the sizes in stock now, from window.__emPackCatalog
 *                    (the same stock the family configurator reads). A tap swaps like the configurator.
 *   Real mums        tap a video card to play it with sound (every other video on the page pauses); "Shop her …"
 *                    shows only when her piece is in stock and isn't the one on screen.
 *   Reviews          this product's own reviews: the first page from Judge.me's widget metafield (a
 *                    <template>, so Judge.me's script never touches it), then Judge.me's public widget
 *                    API for more.
 * Runs on load and after every SPA swap (em:v2:swapped): a swap replaces the regions both parts live in.
 */
(function () {
  'use strict';

  var SPECTRUM = ['shorts', 'long shorts', '3/4', '7/8', 'full length'];
  var SIZES = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'];
  var PER_PAGE = 5;

  function isRecoveryTitle(t) {
    t = String(t || '').toLowerCase();
    if (t.indexOf('bodysuit') >= 0 || t.indexOf('maternity') >= 0) return false;
    return t.indexOf('recovery') >= 0 || t.indexOf('postpartum') >= 0 || t.indexOf('post partum') >= 0;
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // "XS to XXXL" when the sizes run unbroken, otherwise the list.
  function sizeText(list) {
    if (!list.length) return '';
    var idx = list.map(function (s) { return SIZES.indexOf(s); });
    var run = idx.every(function (v, i) { return v >= 0 && (i === 0 || v === idx[i - 1] + 1); });
    if (list.length > 2 && run) return list[0] + ' to ' + list[list.length - 1];
    return list.join(', ');
  }

  // ── Which length? ──────────────────────────────────────────────────────────
  function buildLengths() {
    var sec = document.getElementById('em-rec-length');
    if (!sec || sec.getAttribute('data-wired') === '1') return;
    var cat = window.__emPackCatalog;
    if (!cat || !cat.products) return;
    var cur = sec.getAttribute('data-handle');
    var photos = {};
    try { photos = JSON.parse((sec.querySelector('.em-rec-len-imgs') || {}).textContent || '{}') || {}; } catch (e) {}
    var members = cat.products.filter(function (p) {
      return isRecoveryTitle(p.title) && SPECTRUM.indexOf(String(p.length || '').toLowerCase()) >= 0;
    });
    if (members.length < 2) return;
    members.sort(function (a, b) {
      var d = SPECTRUM.indexOf(String(a.length).toLowerCase()) - SPECTRUM.indexOf(String(b.length).toLowerCase());
      if (d) return d;
      return (a.feature === 'with pockets' ? 1 : 0) - (b.feature === 'with pockets' ? 1 : 0);
    });
    var html = members.map(function (p) {
      var len = String(p.length).toLowerCase();
      var name = len.charAt(0).toUpperCase() + len.slice(1) + (p.feature === 'with pockets' ? ' with pockets' : '');
      var inStock = SIZES.filter(function (s) { return p.sizes && p.sizes[s] && p.sizes[s].avail; });
      var stock = inStock.length ? sizeText(inStock) : 'Sold out right now';
      if (inStock.length && p.finalSale) stock += ', final sale';
      var isCur = p.handle === cur;
      return '<button type="button" class="em-rec-len' + (isCur ? ' is-cur' : '') + (inStock.length ? '' : ' is-out') + '"' +
        ' data-em-rec-handle="' + esc(p.handle) + '"' + (isCur ? ' aria-current="true"' : '') + '>' +
        ((photos[p.handle] || p.image) ? '<img src="' + esc(photos[p.handle] || p.image) + '" alt="" loading="lazy">' : '') +
        '<span class="em-rec-len-n">' + esc(name) + (isCur ? ' (this one)' : '') + '</span>' +
        '<span class="em-rec-len-s">' + esc(stock) + '</span></button>';
    }).join('');
    sec.querySelector('.em-rec-lengths').innerHTML = html;
    sec.hidden = false;
    sec.setAttribute('data-wired', '1');
  }

  document.addEventListener('click', function (e) {
    var tile = e.target.closest && e.target.closest('[data-em-rec-handle]');
    if (!tile || tile.classList.contains('is-cur')) return;
    var handle = tile.getAttribute('data-em-rec-handle');
    e.preventDefault();
    if (typeof window._v2SwapToHandle === 'function') window._v2SwapToHandle(handle);
    else window.location.href = '/products/' + encodeURIComponent(handle);
  });

  // ── Real mums ──────────────────────────────────────────────────────────────
  function inStock(handle) {
    var cat = window.__emPackCatalog;
    var p = cat && cat.products && cat.products.filter(function (x) { return x.handle === handle; })[0];
    if (!p || !p.sizes) return null;
    return SIZES.some(function (s) { return p.sizes[s] && p.sizes[s].avail; });
  }

  function buildMums() {
    var sec = document.getElementById('em-rec-mums');
    if (!sec || sec.getAttribute('data-wired') === '1') return;
    if (!window.__emPackCatalog) return;
    sec.setAttribute('data-wired', '1');
    var cur = (document.getElementById('em-rec-length') || {}).getAttribute ? document.getElementById('em-rec-length').getAttribute('data-handle') : '';
    if (!cur) { try { cur = JSON.parse(document.getElementById('emamaco-pp-meta').textContent).handle; } catch (e) {} }
    sec.querySelectorAll('.em-rec-mum-cta').forEach(function (a) {
      var h = a.getAttribute('data-em-rec-handle');
      a.hidden = !(h !== cur && inStock(h) === true);
    });
  }

  function pauseOthers(except) {
    document.querySelectorAll('video').forEach(function (v) { if (v !== except && !v.paused) { try { v.pause(); } catch (e) {} } });
  }

  var watchOut = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { if (!en.isIntersecting && !en.target.paused) en.target.pause(); });
  }, { threshold: 0.25 }) : null;

  document.addEventListener('click', function (e) {
    var media = e.target.closest && e.target.closest('.em-rec-mum-media');
    if (!media) return;
    var fig = media.closest('.em-rec-mum');
    var src = fig && fig.getAttribute('data-em-rec-video');
    if (!src) return;
    var v = media.querySelector('video');
    if (!v) {
      var img = media.querySelector('img');
      v = document.createElement('video');
      v.src = src;
      v.setAttribute('playsinline', '');
      v.playsInline = true;
      v.controls = true;
      v.preload = 'auto';
      if (img) { v.poster = img.currentSrc || img.src; img.replaceWith(v); } else { media.insertBefore(v, media.firstChild); }
      v.addEventListener('play', function () { pauseOthers(v); fig.classList.add('is-playing'); });
      if (watchOut) watchOut.observe(v);
    }
    pauseOthers(v);
    fig.classList.add('is-playing');
    var pr = v.play();
    if (pr && pr.catch) pr.catch(function () {});
  });

  // The title chips jump to the health fund strip: open it on the way.
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href="#em-rec-fund"]');
    var d = a && document.getElementById('em-rec-fund');
    if (d && d.tagName === 'DETAILS') d.open = true;
  });

  // ── Reviews ────────────────────────────────────────────────────────────────
  function parseReviews(html) {
    var doc = new DOMParser().parseFromString(String(html || ''), 'text/html');
    var out = [];
    doc.querySelectorAll('.jdgm-rev').forEach(function (el) {
      if (el.getAttribute('data-verified-buyer') !== 'true') return;
      var r = el.querySelector('.jdgm-rev__rating');
      var body = el.querySelector('.jdgm-rev__body');
      var paras = body ? Array.prototype.map.call(body.querySelectorAll('p'), function (p) { return p.textContent.trim(); }).filter(Boolean) : [];
      var t = el.querySelector('.jdgm-rev__timestamp');
      var pics = [];
      el.querySelectorAll('.jdgm-rev__pics a.jdgm-rev__pic-link').forEach(function (a) {
        var im = a.querySelector('img');
        var thumb = im && (im.getAttribute('data-src') || im.getAttribute('src'));
        if (thumb && pics.length < 3) pics.push({ thumb: thumb, full: a.getAttribute('href') || thumb });
      });
      out.push({
        id: el.getAttribute('data-review-id') || '',
        score: Math.max(0, Math.min(5, parseInt(r && r.getAttribute('data-score'), 10) || 0)),
        title: (el.querySelector('.jdgm-rev__title') || {}).textContent || '',
        body: paras.length ? paras.join('\n') : (body ? body.textContent.trim() : ''),
        author: (el.querySelector('.jdgm-rev__author') || {}).textContent || '',
        date: t ? (t.getAttribute('datetime') || t.getAttribute('data-content') || '') : '',
        pics: pics
      });
    });
    return out;
  }

  function monthYear(s) {
    var d = new Date(String(s).replace(' UTC', 'Z').replace(' ', 'T'));
    if (isNaN(d.getTime())) return '';
    return d.toLocaleDateString('en-AU', { month: 'long', year: 'numeric' });
  }

  function reviewHtml(v) {
    var stars = '';
    for (var i = 1; i <= 5; i++) stars += i <= v.score ? '&#9733;' : '<span class="off">&#9733;</span>';
    var when = monthYear(v.date);
    return '<div class="em-rec-rev" data-review-id="' + esc(v.id) + '">' +
      '<div class="em-rec-rev-stars" aria-label="' + v.score + ' out of 5">' + stars + '</div>' +
      (v.title.trim() ? '<h3>' + esc(v.title.trim()) + '</h3>' : '') +
      (v.body ? '<p>' + esc(v.body) + '</p>' : '') +
      (v.pics && v.pics.length ? '<div class="em-rec-rev-pics">' + v.pics.map(function (p) {
        return '<a href="' + esc(p.full) + '" target="_blank" rel="noopener"><img src="' + esc(p.thumb) + '" alt="" loading="lazy"></a>';
      }).join('') + '</div>' : '') +
      '<div class="em-rec-rev-by">' + esc(v.author.trim()) + (when ? ' &middot; ' + esc(when) : '') + ' &middot; Verified buyer</div>' +
      '</div>';
  }

  function appendReviews(sec, list) {
    var box = sec.querySelector('.em-rec-rev-list');
    var seen = {};
    box.querySelectorAll('[data-review-id]').forEach(function (n) { seen[n.getAttribute('data-review-id')] = 1; });
    box.insertAdjacentHTML('beforeend', list.filter(function (v) { return !v.id || !seen[v.id]; }).map(reviewHtml).join(''));
    // Long reviews show six lines and a Read more.
    requestAnimationFrame(function () {
      box.querySelectorAll('.em-rec-rev:not([data-measured])').forEach(function (n) {
        n.setAttribute('data-measured', '1');
        var p = n.querySelector('p');
        if (p && p.scrollHeight > p.clientHeight + 2) p.insertAdjacentHTML('afterend', '<button type="button" class="em-rec-rev-open">Read more</button>');
      });
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.em-rec-rev-open');
    if (!b) return;
    b.parentNode.classList.add('is-open');
    b.parentNode.removeChild(b);
  });

  function buildReviews() {
    var sec = document.getElementById('em-rec-reviews');
    if (!sec || sec.getAttribute('data-wired') === '1') return;
    sec.setAttribute('data-wired', '1');
    var src = sec.querySelector('template.em-rec-rev-src');
    appendReviews(sec, parseReviews(src ? src.innerHTML : ''));
    var more = sec.querySelector('.em-rec-more');
    var pages = Math.ceil((parseInt(sec.getAttribute('data-count'), 10) || 0) / PER_PAGE);
    var page = 1;
    if (!more || pages <= 1) return;
    more.hidden = false;
    more.addEventListener('click', function () {
      if (more.disabled) return;
      more.disabled = true;
      var shop = sec.getAttribute('data-shop');
      var url = 'https://api.judge.me/reviews/reviews_for_widget?url=' + encodeURIComponent(shop) +
        '&shop_domain=' + encodeURIComponent(shop) + '&platform=shopify&page=' + (page + 1) +
        '&per_page=' + PER_PAGE + '&product_id=' + encodeURIComponent(sec.getAttribute('data-product-id'));
      fetch(url).then(function (r) { if (!r.ok) throw new Error('reviews ' + r.status); return r.json(); })
        .then(function (d) {
          if (!sec.isConnected) return;
          page += 1;
          appendReviews(sec, parseReviews(d && d.html));
          more.disabled = false;
          if (page >= pages) more.hidden = true;
        })
        .catch(function () { more.disabled = false; });
    });
  }

  // The stars under the title jump to the reviews: on a recovery product that is this product's own list
  // (the store-wide widget is hidden). Capture phase on window, so it runs before the theme's handler.
  window.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('#em-scroll-to-reviews');
    if (!btn) return;
    var rv = document.getElementById('em-rec-reviews');
    if (!rv || !rv.offsetHeight) return;
    e.preventDefault();
    e.stopPropagation();
    window.scrollTo({ top: rv.getBoundingClientRect().top + window.pageYOffset - 20, behavior: 'smooth' });
  }, true);

  function init() {
    try { buildLengths(); } catch (e) { if (window.console) console.warn('[em-rec] lengths', e); }
    try { buildMums(); } catch (e) { if (window.console) console.warn('[em-rec] mums', e); }
    try { buildReviews(); } catch (e) { if (window.console) console.warn('[em-rec] reviews', e); }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // The pack catalog is parsed by an inline script near the end of the page; catch it if it lands late.
  window.addEventListener('load', init);
  window.addEventListener('em:v2:swapped', init);
})();
